import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { SortAscending } from "@phosphor-icons/react";

const OPTIONS = [
  ["featured", "Featured"],
  ["rating", "Best rated"],
  ["reviews", "Most reviewed"],
  ["price_asc", "Price: low to high"],
  ["price_desc", "Price: high to low"],
];

const price = (p, dir) => (p.min_price ?? (dir > 0 ? Infinity : -Infinity));

export function sortProducts(list, sort) {
  if (sort === "featured") return list;
  const arr = [...list];
  const cmp = {
    rating: (a, b) => (b.rating_avg || 0) - (a.rating_avg || 0) || (b.rating_count || 0) - (a.rating_count || 0),
    reviews: (a, b) => (b.rating_count || 0) - (a.rating_count || 0) || (b.rating_avg || 0) - (a.rating_avg || 0),
    price_asc: (a, b) => price(a, 1) - price(b, 1),
    price_desc: (a, b) => price(b, -1) - price(a, -1),
  }[sort];
  return cmp ? arr.sort(cmp) : list;
}

export default function SortMenu({ value, onChange }) {
  return (
    <div className="relative">
      <SortAscending size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground pointer-events-none z-10" />
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger data-testid="sort-select" className="h-11 w-full sm:w-52 rounded-sm bg-white pl-9">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {OPTIONS.map(([v, label]) => (
            <SelectItem key={v} value={v} data-testid={`sort-option-${v}`}>{label}</SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
